import { writable } from 'svelte/store';
export const SUBSCRIPTION_STORE = writable({});
export const SUBSCRIPTION_HASH = writable('initial');
